import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { usePublicConfig } from './providers/publicConfig';

export const initSentry = ({ dsn }: { dsn: string }) => {
  if (process.env.NODE_ENV === 'development') {
    return;
  }

  try {
    Sentry.init({
      dsn,
      environment: process.env.REACT_APP_PV_ENV,
      integrations: [Sentry.browserTracingIntegration()],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.01,
      ignoreErrors: [
        'TypeError: Load failed',
        'TypeError: Failed to fetch',
        'TypeError: The network connection was lost.',
        'TypeError: The Internet connection appears to be offline.',
        'ChunkLoadError',
      ],
      denyUrls: [
        /graph\.facebook\.com/i,
        /api\.louassist\.com/i,
        /forms\.hubspot\.com/i,
        /^chrome:\/\//i,
        /^localhost:/i,
      ],
    });
  } catch (error) {
    console.error('Sentry failed to initialize; continuing without it', error);
  }
};

export const SentryUser = () => {
  const { publicConfig } = usePublicConfig();

  useEffect(() => {
    if (publicConfig?.sentryUser?.id) {
      Sentry.setUser(publicConfig?.sentryUser);
    }
  }, [publicConfig?.sentryUser?.id]);

  return null;
};

export const captureException = (
  exception: any,
  captureContext?: Sentry.ExclusiveEventHintOrCaptureContext | undefined
): string => Sentry.captureException(exception, captureContext);

export const captureMessage = (
  message: string,
  captureContext?: Sentry.CaptureContext | Sentry.SeverityLevel | undefined
): string => Sentry.captureMessage(message, captureContext);
